import React from 'react';

export default class MobileWrapperMask extends React.Component {
	handleClick(){
		document.body.classList.remove( 'body--leftexpanded' );
		document.body.classList.remove( 'body--rightexpanded' );
	}
	render() {
		return <div className="wrapper__mask" id="J-wrapper-mask" onClick={this.handleClick}></div>;
	}
}


// WEBPACK FOOTER //
// ./app/components/MobileWrapperMask.js